// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"355":"d6f73dc0","767":"82a63b84","771":"d06aa946","795":"075d0faf"}[chunkId] + ".css";
};